import { Injectable, signal, WritableSignal, Signal, computed, inject } from '@angular/core';
import { UserResponseData } from '../dto/authentication.dto';
import { AuthenticationFactory } from './authentication.factory';
import { LocalStorageService } from '../services/local-storage.service';

@Injectable({ providedIn: 'root' })
export class SessionService {
    
    private authFactory: AuthenticationFactory = inject(AuthenticationFactory);
    private localStorageSvc: LocalStorageService = inject(LocalStorageService);

    public saveSession(token: string, user: UserResponseData): void {
        this.localStorageSvc.setToken(token);
        this.localStorageSvc.setUser(user);
    }

    public clearSession(): void {
        this.localStorageSvc.removeToken();
        this.localStorageSvc.removeUser();
    }

    public getToken(): string | null {
        return this.localStorageSvc.getToken();
    }

    public getUser(): UserResponseData | null {
        return this.localStorageSvc.getUser();
    }

    public async isAuthenticated(): Promise<boolean> {
        
        const user = this.localStorageSvc.getUser();
        const token = this.localStorageSvc.getToken();

        if (user && token) {
            try {
                await this.authFactory.validateToken({ token, type: 'login' });
                return true;
            } catch {}
        }

        this.clearSession();
        return false;

    }
    
}
